export default __webpack_public_path__ + "static/media/noimage.73e7eb3f.png";